import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import "../styles/TeacherVideoUploadForm.css";
import TeacherStudentHeader from "../components/TeacherStudentHeader";

// import history from "../images/history.png";
import TeacherVideoUploadForm from "../components/TeacherVideoUploadForm";
import "../styles/TeacherVideoUploadFormPage.css";
// import tutorials from "../images/tutorials.png";
import { teacherMenuItems } from "../components/TeacherMenuItems";
import AccessTokenModal from "../components/AccessTokenModal";

const TeacherVideoUploadFormPage = ({ onClose }) => {
  const [activeItem, setActiveItem] = useState("home");
  const [isVideoMode, setIsVideoMode] = useState(true);
  const [searchQuery, setSearchQuery] = useState("");
  const navigate = useNavigate();

  const resetSearch = () => {
    setSearchQuery(""); // Reset the search query
  };

  const toggleMode = (mode) => {
    setIsVideoMode(mode);
  };

  const getHeaderVisibility = () => {
    if (activeItem === "feedback") {
      return { showSearch: false, showToggle: false, showUserProfile: true };
    } else if (activeItem === "tutorials") {
      return { showSearch: true, showToggle: false, showUserProfile: true };
    }
    return { showSearch: false, showToggle: false, showUserProfile: true };
  };
  const { showSearch, showToggle, showUserProfile } = getHeaderVisibility();

  const handleActiveItemChange = (item) => {
    setActiveItem(item); // Update active item

    // Navigate to the correct route
    if (item === "feedback") {
      navigate("/teacherFeedback"); // Navigate to feedback page
    } else if (item === "home") {
      navigate("/teacher"); // Navigate to home page
    }

    resetSearch(); // Reset search whenever a new section is selected
  };

  return (
    <div className="dashboard">
      <TeacherStudentHeader
        isVideoMode={isVideoMode}
        toggleMode={toggleMode}
        showSearch={showSearch}
        showToggle={showToggle}
        showUserProfile={showUserProfile}
        searchQuery={searchQuery}
        onSearch={(query) => setSearchQuery(query)}
        teacherMenuItems={teacherMenuItems}
        activeItem={activeItem}
        setActiveItem={handleActiveItemChange}
      />
      <main className="main-content">
        {/* <Sidebar
          activeItem={activeItem}
          setActiveItem={handleActiveItemChange}
          menuItems={teacherMenuItems}
          resetSearch={resetSearch}
        /> */}
        <div className="content">
          <TeacherVideoUploadForm />
        </div>
      </main>
      <AccessTokenModal />
    </div>
  );
};

export default TeacherVideoUploadFormPage;
